import React from "react";
import { PageTitle } from "../../../martin/_partials";

export default function Uix() {
    return (
        <>
            <div className="martin-narrow-content content-section">
                <PageTitle heading={"UI/UX Design"} headingMeta={"Portfolio"} />
                <div className="row">
                    <div className="col-md-12 col-md-offset-3 col-md-pull-3">
                        <p className="opacity-70" style={{ margin: '40px 0 20px 0' }}>
                            <strong>No designs found</strong>
                            <small style={{ display: 'block', lineHeight: '1' }}>There's nothing to display</small>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}